export const attachmentHasTranslatedImage = attachment => {
  return !!(attachment?.translatedDataUrl || attachment?.translated_data_url);
};

export const resolveTranslatedImageAttachment = (
  attachment,
  { showingOriginal = false } = {}
) => {
  if (!attachment) return attachment;
  if (showingOriginal || !attachmentHasTranslatedImage(attachment)) {
    return attachment;
  }

  return {
    ...attachment,
    dataUrl: attachment.translatedDataUrl || attachment.translated_data_url,
    thumbUrl: attachment.translatedThumbUrl || attachment.translated_thumb_url,
    width: attachment.translatedWidth || attachment.translated_width,
    height: attachment.translatedHeight || attachment.translated_height,
    internalDownloadUrl:
      attachment.translatedInternalDownloadUrl ||
      attachment.translated_internal_download_url ||
      attachment.internalDownloadUrl,
    internal_download_url:
      attachment.translated_internal_download_url ||
      attachment.translatedInternalDownloadUrl ||
      attachment.internal_download_url,
  };
};
